export default __webpack_public_path__ + "static/sync-09c462d3f7e88df802d53aae7705ea99.gif";